import { Form, Input, Button, message, Modal } from "antd";
import { useEffect } from "react";
import AnimateItems from "../../../utils/AnimateItems";
import axios from "axios";

export default function TransformadorForm(props) {
  const { visible, title, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(verification);
  }, [verification, form]);

  return (
    <>
      <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800}>
        <Form form={form} layout="vertical">
          <AnimateItems delay={0.35}>
            <Form.Item name="TipoTR" label="Tipo de transformador">
              <Input />
            </Form.Item>
            <Form.Item name="CapacidadTR" label="Capacidad">
              <Input />
            </Form.Item>
            <Form.Item name="MarcaTR" label="Marca">
              <Input />
            </Form.Item>
            <Form.Item name="NumeroSerieTR" label="Número de serie">
              <Input />
            </Form.Item>
            <Form.Item name="ImpedanciaTR" label="Impedancia">
              <Input />
            </Form.Item>
            <Form.Item name="FechaFabricacionTR" label="Fecha de fabricación">
              <Input />
            </Form.Item>
            <Form.Item name="EficienciaTR" label="Eficiencia">
              <Input />
            </Form.Item>
          </AnimateItems>
        </Form>
        <Button
          type="primary"
          onClick={() => {
            const verificationData = { ...verification, ...form.getFieldsValue() };
            axios
              .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, verificationData)
              .then(() => {
                message.success("Campos actualizados correctamente");
                setVerification(verificationData);
                setVisible(false);
              })
              .catch((err) => {
                message.error("Error al actualizar los campos");
              });
          }}
        >
          Guardar
        </Button>
      </Modal>
    </>
  );
}
